export function dataInRequest(params = {}) {
  return {
    type: '@retransregisintegracao/DATA_IN_REQUEST',
    payload: { params },
  };
}

export function findData(id) {
  return {
    type: '@retransregisintegracao/FIND_DATA',
    payload: { id },
  };
}

export function failedRequest() {
  return {
    type: '@retransregisintegracao/FAILED_REQUEST',
  };
}

export function deleteData(id, params) {
  return {
    type: '@retransregisintegracao/DELETE_DATA',
    payload: { id, params },
  };
}

export function updateData(data, params) {
  return {
    type: '@retransregisintegracao/UPDATE_DATA',
    payload: { data, params },
  };
}

export function storeData(data, params) {
  return {
    type: '@retransregisintegracao/STORE_DATA',
    payload: { data, params },
  };
}

export function successInRequest(data, page, pageSize, totalCount, totalPages) {
  return {
    type: '@retransregisintegracao/SUCCESS_IN_REQUEST',
    payload: { data, page, pageSize, totalCount, totalPages },
  };
}

export function successRequest(data) {
  return {
    type: '@retransregisintegracao/SUCCESS_REQUEST',
    payload: { data },
  };
}

export function successRemove(params) {
  return {
    type: '@retransregisintegracao/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@retransregisintegracao/RECORD_FILTERING',
    payload: { params },
  };
}
